import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
const CanonicalManager = () => {
  const location = useLocation();
  useEffect(() => {
    const baseUrl = `${window.location.protocol}//${window.location.hostname}${
      window.location.port ? `:${window.location.port}` : ""
    }`;
    const path = location.pathname === "/" ? "" : location.pathname;
    const canonicalUrl = `${baseUrl}${path}`;

    let existing = document.querySelector('link[rel="canonical"]');
    if (!existing) {
      existing = document.createElement("link");
      existing.rel = "canonical";
      document.head.appendChild(existing);
    }
    existing.href = canonicalUrl;
  }, [location.pathname]);

  return null;
};

export default CanonicalManager;
